// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  'CATEGORY_API': 'https://analytics.wowyourdata.com/wp-json/customAPI/ervos',
  'REPORTS_API': 'https://analytics.wowyourdata.com/wp-json/customAPI/ervos?cat=',
  'POSTS_ALL_API': 'https://analytics.wowyourdata.com/wp-json/customAPI/all',
  'BLOG_POSTS_API': 'https://analytics.wowyourdata.com/wp-json/customAPI/blog',
  'BLOG_SINGLE_POSTS_API': 'https://analytics.wowyourdata.com/wp-json/customAPI/blog?id=',
  'POST_COUNT': 'https://analytics.wowyourdata.com/wp-json/customAPI/count',
  'FAVORITE_REPORTS': 'https://analytics.wowyourdata.com/wp-json/customAPI/favorites',
  'SET_FAVORITE_REPORTS': 'https://analytics.wowyourdata.com/wp-json/customAPI/setfavorites?post_id=',
  'REMOVE_FAVORITE_REPORTS': 'https://analytics.wowyourdata.com/wp-json/customAPI/removefavorites?post_id=',
  'UPDATE_REPORT_VIEW_BY_USER': 'https://analytics.wowyourdata.com/wp-json/customAPI/update-view-counter-by-user?reportID=',
  'UPDATE_REPORT_VIEW_COUNTER': 'https://analytics.wowyourdata.com/wp-json/customAPI/update-view-counter?reportID=',
  'LIKE_REPORT': 'https://analytics.wowyourdata.com/wp-json/customAPI/like-report?reportID=',
  'LOGOUT_USER': 'https://analytics.wowyourdata.com/wp-json/customAPI/logout',
  'FAQ_CONTENT': 'https://analytics.wowyourdata.com/wp-json/customAPI/faq-content',
  'LOGIN_URL': 'https://analytics.wowyourdata.com/wp-admin/',
  'CONTACT_FORM_PAGE_URL': 'https://analytics.wowyourdata.com/contact-us-form/'
};
